import cn from 'bem-cn';

import { Stack, TextArea } from '../../../components/UI';
import { InfoBlock } from '../../../components/UI/InfoBlock/InfoBlock';

import { PromptTextStepProps } from './PromptTextStep.types';

import './PromptTextStep.scss';

const b = cn('prompt-text-step');

export const PromptTextStep = ({ promptText, onPromptTextChange, error }: PromptTextStepProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onPromptTextChange(e.target.value);
    };

    return (
        <>
            <InfoBlock text="Промпт будет опубликован в общем каталоге и станет доступен всем" />
            <Stack spacing={16}>
                <h2 className={b('title')}>Промпт</h2>
                <TextArea
                    placeholder="Напишите свой промпт"
                    value={promptText}
                    onChange={handleChange}
                    error={error}
                    autoResize
                />
            </Stack>
        </>
    );
};
